// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TimelineEvent from './view'

export default function TimelineEventFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TimelineEvent">
      <TimelineEvent {...props}>
        {children}
      </TimelineEvent>
    </Flow>
  )
}
